import React from 'react'
import cx from 'classnames'
import MenuLink from 'components/layout/MenuLink'
import AccountMenu from 'components/layout/AccountMenu'
import { UrlIdpRedirect } from 'helpers/redirects'

const Menu = ({
  className,
  isExternalAuth,
  isLogged,
  flavour,
  aol,
  menuItems
}) => {
  return (
    <div className='w-100 bg-light-bluish-grey'>
      <nav
        data-help-item='menu'
        data-help-position='bottom'
        className={cx(
          'pv3 dn-t flex layout-width-constraint items-center justify-between',
          className
        )}
      >
        <div className='w-10' />
        <div className='flex'>
          {menuItems.map((item, key) => <MenuLink key={`${item.title}-${key}`} {...item} />)}
        </div>

        <div className='w-11-half flex justify-end'>
          {isLogged && (
            <AccountMenu {...{ isExternalAuth, isLogged, flavour, aol }} />
          )}
          {!isLogged && (
            <a
              className='no-underline hover-underline black fw6 tr pr5'
              href={UrlIdpRedirect()}
            >
              Sign in
            </a>
          )}
        </div>
      </nav>
    </div>
  )
}

export default Menu
